export enum ConditionGroupType {
	Normal = 1,
	Fixed = 2
}